import { JobPosting, WithContext } from "schema-dts"

const employmentType = {
  PART_TIME: "アルバイト",
  FULL_TIME: "正社員",
  // CONTRACTOR: "契約社員",
  // TEMPORARY: "派遣社員",
  // INTERN: "インターン",
  // PER_DIEM: "日雇い",
  // VOLUNTEER: "ボランティア",
  // OTHER: "その他雇用形態(要問合せ)"
} as const

const salaryUnit = {
  HOUR: "時給",
  DAY: "日給",
  WEEK: "週給",
  MONTH: "月給",
  YEAR: "年俸"
} as const

const currencyCode = {
  JPY: "円"
} as const

const location = {
  TELECOMMUTE: "リモートワーク",
  COMMUTE: "オフィスワーク",
  EITHER: "どちらでも"
} as const

interface Job {
  /**
   * 有効な求人か
   */
  active: boolean
  /**
   * www.mksc.jp/jobs/:slug というURLになる
   * 求人情報IDとしても使う、よって同一求人は一意となるIDが望ましい
   */
  slug: string
  title: string
  titleEng: string
  employmentType: keyof typeof employmentType
  location: keyof typeof location
  tags: string[]
  salary: {
    currencyCode: keyof typeof currencyCode
    min: number
    max: number
    unit: keyof typeof salaryUnit
  },
  skill: {
    required: string
    optional: string
    technologies: string[]
  },
  works: string[]
  /**
   * google検索のリンクの下に表示される小さい文字
   */
  description: string
  applicantLocationRequirements?: WithContext<JobPosting>["applicantLocationRequirements"]
}
export { currencyCode, employmentType, location, salaryUnit }
export type { Job }

